import React from 'react';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-inner">
        <p>&copy; 2026 <strong>Hospitality</strong> - Hospital Management System. All rights reserved.</p>
        <p className="footer-sub">Built with React | Modern Healthcare Solutions</p>
      </div>
    </footer>
  );
};

export default Footer;
